import axios from "axios";
import { getToken } from "@/lib/auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Multi-struttura: attach active property id (selected from top bar)
  const propertyId = localStorage.getItem("admin_active_property");
  if (propertyId) {
    config.headers["X-Property-Id"] = propertyId;
  }
  return config;
});

export default api;
